import React from 'react';
import { gradeColor } from '../../helpers';

// Renders a coloured Grade badge. Optionally accepts the full `decision`
// row to fall back to a STRATA advisory tier_v1 when the authoritative
// `grade` is missing or literally 'no grade'.
//
// Advisory rendering: italic muted text with an 'adv' superscript and a
// tooltip that's explicit about the ~88% accuracy and the no-sizing
// constraint. The badge does NOT render the advisory with the same
// coloured background as an authoritative grade — visually it's clearly
// a different thing.
export default function GradeBadge({ grade, decision }) {
  const isMissingAuthoritative = !grade || grade === 'no grade';
  const adv      = decision && decision.tier_v1_advisory;
  const advPur   = decision && decision.tier_v1_advisory_purity;
  const advSrc   = decision && decision.tier_v1_advisory_source;

  // Advisory takes over only when the authoritative grade is absent.
  if (isMissingAuthoritative && adv) {
    return (
      <span style={{ color: 'var(--tv-text-muted)', fontStyle: 'italic',
                     fontSize: 10, fontWeight: 600, letterSpacing: '0.05em' }}
            title={`Diagnostic advisory grade — ~88% accurate (time-of-day lookup). `
                  + `Slot purity: ${advPur != null
                      ? `${(advPur * 100).toFixed(0)}%`
                      : 'n/a'}. `
                  + `Source: ${advSrc || 'STRATA grader advisory'}. `
                  + `NEVER used for sizing — display only, awaiting `
                  + `authoritative grader from upstream research.`}>
        {adv}
        <sup style={{ fontSize: 7, marginLeft: 2, opacity: 0.7 }}>adv</sup>
      </span>
    );
  }

  // No authoritative grade AND no advisory => the trade fired in the overnight
  // (Globex) session, outside the 9am–3pm ET window the STRATA grader covers.
  // Show 'overnight' with an explanatory tooltip so a blank grade reads as
  // "no grade applies here", not "grade missing / bug".
  const offSession = decision && decision.grade_session;
  if (isMissingAuthoritative && offSession) {
    return (
      <span style={{ color: 'var(--tv-text-muted)', fontStyle: 'italic',
                     fontSize: 10, fontWeight: 600, letterSpacing: '0.05em' }}
            title={'No STRATA grade for this trade — it fired in the overnight '
                  + '(Globex) session, outside the 9am–3pm ET window the grader '
                  + 'covers. The v1.10 book has no overnight grades by construction.'}>
        overnight
      </span>
    );
  }

  if (!grade) return <span style={{ color: 'var(--tv-text-muted)' }}>—</span>;
  const c = gradeColor(grade);
  return (
    <span className="badge" style={{ background: c.bg, border: `1px solid ${c.border}`, color: c.color }}>
      {grade}
    </span>
  );
}
